module.exports = __webpack_public_path__ + "static/img/thumb-03.3caef8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/j_t/thumb/thumb-03.png
// module id = ohqW
// module chunks = 31